"use strict";

// This `JSON` type def is really JSON-ish.
// We include Dates in our JSON definition due to popular demand.
// Lots of users blindly pass Dates back up through their API.
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isContainer = exports.isObject = exports.isArray = void 0;
function isArray(value) {
  return Array.isArray(value);
}
exports.isArray = isArray;
function isObject(value) {
  if (value === null) {
    return false;
  }
  if (typeof value !== "object") {
    return false;
  }
  if (isArray(value)) {
    return false;
  }
  if (value instanceof Date) {
    return false;
  }
  return true;
}
exports.isObject = isObject;
function isContainer(value) {
  return isArray(value) || isObject(value);
}
exports.isContainer = isContainer;